import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { TextField } from '@mui/material';
import Stack from '@mui/material/Stack';
import { useSnackbar } from '../../../context/SnackbarContext';
import { useTranslation } from 'react-i18next';
import { useCreateInventoryCategory } from '../../../hooks/inventory/useCreateInventoryCategory';
import { useUpdateInventoryCategory } from '../../../hooks/inventory/useUpdateInventoryCategory';

export default function InventoryCategoryForm({ successCallback = null, inventoryCategory = null, mode = "create", open, onClose }) {

    const { t } = useTranslation('common'); 

    const [name, setName] = React.useState(inventoryCategory ? inventoryCategory.name : "");
    const [description, setDescription] = React.useState(inventoryCategory ? inventoryCategory.description : "");

    const { create } = useCreateInventoryCategory(successCallback);
    const { update } = useUpdateInventoryCategory(successCallback);

    const { showSnackbar } = useSnackbar();

    React.useEffect(() => {
        // reset field when there are changes (e.g. when opening edit)
        setName(inventoryCategory ? inventoryCategory.name : "");
        setDescription(inventoryCategory ? inventoryCategory.description : "");
    }, [inventoryCategory, open]);

    const handleSave = async () => {
        if (!name.trim()) {
            showSnackbar(t('inventory.categories.messages.name_required'), "warning");
            return;
        }

        try 
        {
            if (mode === "create") {
                await create({ 
                    name: name,
                    description: description
                });
                showSnackbar(t('inventory.categories.messages.create_success'), "success");
            } else if (mode === "edit" && inventoryCategory) {
                await update(inventoryCategory.id, { 
                    name: name,
                    description: description
                 });
                showSnackbar(t('inventory.categories.messages.update_success'), "success");
            }
            // clear field after save
            setName("");   
            setDescription("");
            // close dialog
            onClose();     
        } catch (err) {
            console.log("err.response", err.response);   
            showSnackbar(t('inventory.categories.messages.save_fail'), "error");
        }
    };

    const handleCancel = () => {
        setName("");   // clear field on cancel
        setDescription("");
        onClose();
    };

    return (
        <>
        <Dialog onClose={handleCancel} open={open} disableRestoreFocus>

        <DialogTitle>{mode === "create" ? "Add Category" : "Edit Category"}</DialogTitle>

        <DialogContent dividers>
            <Stack spacing={1}>
            <TextField
                label="Name"
                variant="outlined"
                value={name}
                onChange={(e) => setName(e.target.value)}
                fullWidth
            />
            <TextField
                label="Description"
                variant="outlined"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                fullWidth
                multiline
                rows={3}
            />
            </Stack>
        </DialogContent>

        <DialogActions>
            <Button onClick={handleSave}>
                Save
            </Button>
            <Button onClick={handleCancel}>Cancel</Button>
        </DialogActions>
        </Dialog>
        </>
    );
}